<template>
    <b-row key="datos-comprador" id="datos-comprador">
        <b-col sm="12">
            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                <div class="row">
                    <b-col cols="12" col-md="10">
                        <FormInput
                            v-model="datos_comprador.nombre"
                            id="nombre"
                            rules="required" 
                            :label="'Nombre'"
                            :name="'nombre'"
                        />
                    </b-col>
                    <b-col cols="12" col-md="10">
                        <FormInput
                            v-model="datos_comprador.apellido"
                            id="apellidos"
                            rules="required" 
                            :label="'Apellidos'"
                            :name="'apellidos'"
                        />
                    </b-col>
                    <b-col cols="12" col-md="10">
                        <FormInput
                            v-model="datos_comprador.edad"
                            id="edad"
                            rules="required|min_value:18|max_value:99" 
                            :label="'Edad'"
                            :name="'edad'"
                        />
                    </b-col>
                    <b-col cols="12" col-md="10">
                        <FormInput
                            v-model="datos_comprador.dni"
                            id="dni"
                            rules="required" 
                            :label="'DNI'"
                            :name="'dni'"
                        />
                    </b-col>
                    <b-col cols="12" col-md="10">
                        <div class="form-group">
                            <label>{{ 'Teléfono' }}</label>
                            <PhoneInput 
                                :phone="datos_comprador.telefono ?? null"
                                :required="true"
                                :error_telefono="error_telefono"
                                rules="required"
                                @setNumber="(number) => datos_comprador.telefono = number"
                                @validNumber="(valid) =>  isValidNumber = valid"
                            />
                        </div>
                    </b-col>
                    <b-col cols="12" col-md="10">
                        <FormInput
                            v-model="datos_comprador.email"
                            id="email"
                            vid="confirmation"
                            rules="required|email"
                            :label="'Email'"
                            :name="'email'"
                        />
                    </b-col>
                    <b-col cols="12" col-md="10">
                        <FormInput
                            v-model="datos_comprador.confirmar_email"
                            id="email_confirmation"
                            :rules="'required|confirmed_ci:@confirmation'"
                            :label="'Confirmar Email'"
                            :name="'confirmar_email'"
                        />
                    </b-col>
                    <b-col cols="12 my-2">
                        <p class="mb-2">Las parcelas adquiridas llegarán al email que nos has indicado, recuerda revisarlo correctamente para que puedan llegarle. Es posible que estas accedan a la carpeta de SPAM de su bandeja, por lo que deberá revisarlo si en los próximos minutos no las ha recibido, escríbenos.</p>
                    </b-col>
                    <b-col cols="12" md="6" v-for="(parcela, index) in datosParcelas" :key="index">
                        <div class="card">
                            <div class="card-header bg-secondary">
                                <span for="precio">{{ 'Parcela' + ' Nº ' + parcela.numero }}</span>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label for="precio">Precio</label>
                                    <ValidationProvider 
                                        :name="'precio parcela' + ' Nº ' + ++index" 
                                        rules="required" 
                                        mode="passive" 
                                        v-slot="{ errors }"
                                    >
                                        <select class="form-control" v-model="parcela.precioSeleccionado">
                                            <template v-for="(precio, index) in parcela.precios">
                                                <option  :key="index" :value="precio">{{ precio.descripcion }} / {{ precio.precio | formatear_precio }}</option>
                                            </template>
                                        </select>
                                        <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="width: 98%; display: block; background-color: red; color: white; padding: 2px;">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                                <div class="form-group">
                                    <label for="descuento">Descuento</label>
                                    <ValidationProvider name="descuento" v-slot="{ errors }">
                                        <select v-model="parcela.descuento" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" id="descuento">
                                            <option disabled value="">Selecciona un descuento</option>
                                            <option v-for="valor in [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100]" :key="valor" :value="valor">{{ valor }}%</option>
                                        </select>
                                        <span class="invalid-feedback">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <div class="col-12 mt-2">
                        <div class="form-group">
                            <label for="metodo_pago">Método de pago / Tipo de Impresión</label>
                            <ValidationProvider name="metodo_pago" rules="required" v-slot="{ errors }">
                                <select v-if="metodos_pago" v-model="pago" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" id="metodo_pago">
                                    <template v-for="(metodo, index) in metodos_pago">
                                        <option :key="index" :value="metodo.id">{{ metodo.nombre }}</option>
                                    </template>
                                </select>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="col-12 mt-3 mb-4 mb-md-0">
                        <DatosLegales :datos="datos_comprador"/>
                    </div>
                    <b-col cols="12" class="mt-4">
                        <Button type="submit" class="btn-block" :disabled="loading" id="compra-responsive" >CONTINUAR COMPRA</Button>
                    </b-col>
                </div>
            </ValidationObserver>
        </b-col>
    </b-row>
</template>

<script>
    import PhoneInput from '@/components/common/PhoneInput';
    import DatosLegales from '@/components/backend/stepper/components/DatosLegales';


    export default {
        props: {
            datosParcelas: {
                type: Array,
                required: true
            },
            cart_id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                datos_comprador: {},
                pago: null,
                isValidNumber: false,
                error_telefono: 0,
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();

                if (!this.datos_comprador.telefono) {
                    this.error_telefono = 1;
                }

                if(isValid && this.isValidNumber && this.datos_comprador.telefono) {
                    this.terminar();
                }
            },
            terminar() {
                this.loading = true;

                const params = {
                    lista_id: this.lista.id,
                    cart_id: this.cart_id,
                    datos_compradores: [this.datos_comprador],
                    metodo_pago: this.pago,
                    parcelas: this.datosParcelas.map(parcela => ({ id: parcela.id, precio_id: parcela.precioSeleccionado.id, descuento_porcentaje: parcela.descuento }))
                };

                this.$store.dispatch(this.config.getVuexAlias('back.parcelas.carrito.guardar-datos-comprador'), params).then(res => {
                    this.$emit('finalizarPasoTres', this.datosParcelas, this.pago);
                }).finally(() => {
                    this.loading = false;
                });
            },
            customLabel({ descripcion, precio }) {
                return `${descripcion} – ${this.$n(precio, 'currency')}`
            }
        },
        computed: {
            esMovil() {
                return window.innerWidth < 768; 
            },
            metodos_pago() {
                let metodos_de_pago = this.teatro.metodos_pago_eventos.slice().filter(metodo_pago => metodo_pago.show_taquilla);
                return metodos_de_pago;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            lista() {
                return this.$store.getters.getListaAbonados;
            },
        },
        mounted() {
            this.datosParcelas.forEach(parcela => {
                if (parcela.descuento === undefined) {
                    this.$set(parcela, 'descuento', 0);
                }
            });
        },
        components: {
            PhoneInput,
            DatosLegales
        }   
    }
</script>

<style scoped>
    .custom-width {
        width: 97.8%;
    }

    @media screen and (max-width: 768px) {
        .custom-width {
            width: 92.7% !important;
        }
    }
</style>